import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["start", "end", "byDate"];

  connect() {
    requestAnimationFrame(() => {
      this.constrainEnd();
      this.constrainStart();
      if (this.fullRangeRequired) {
        this.syncByDate();
      }
      this.refreshField(this.startTarget);
      this.refreshField(this.endTarget);
    });
  }

  startChanged() {
    this.constrainEnd();
    this.refreshField(this.startTarget);

    if (this.fullRangeRequired) {
      this.syncByDate();

      // Wait for the other end of the range instead of applying a half-finished filter.
      if (this.startTarget.value && !this.endTarget.value) {
        requestAnimationFrame(() => this.endPicker?.open());
        return;
      }
    }

    this.apply();
  }

  endChanged() {
    this.constrainStart();
    if (this.fullRangeRequired) {
      this.syncByDate();
    }
    this.refreshField(this.endTarget);
    this.apply();
  }

  clearStart() {
    this.startPicker?.clear();
  }

  clearEnd() {
    this.endPicker?.clear();
  }

  apply() {
    this.element.closest("form").requestSubmit();
  }

  // by_date is only set once both ends are picked, so a half-finished range never
  // gets applied by WebinarFilter.
  syncByDate() {
    const complete = this.startTarget.value !== "" && this.endTarget.value !== "";
    this.byDateTarget.value = complete ? "1" : "";
  }

  constrainEnd() {
    this.endPicker?.set("minDate", this.startTarget.value || null);
  }

  constrainStart() {
    this.startPicker?.set("maxDate", this.endTarget.value || null);
  }

  refreshField(input) {
    input.closest(".date-range-field")?.classList.toggle("has-value", input.value !== "");
  }

  get startPicker() {
    return this.startTarget._flatpickr;
  }

  get endPicker() {
    return this.endTarget._flatpickr;
  }

  // Forms without by_date flag (e.g. contacts) can be submitted with a half-finished range
  get fullRangeRequired() {
    return this.hasByDateTarget;
  }
}
